export default "__VITE_ASSET__e$2_QB58__"